/*
 * @Description: 考勤分析
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const attenceAnalysisRouter: Array<RouteRecordRaw> = [
    {
      path: '/attenceAnalysis',
      component: Layout,
      redirect: '/attenceAnalysis/attenceLists',
      meta: { title: '考勤分析' },
      children: [
          {
              path: 'attenceLists',
              component: () => import(/* webpackChunkName: "attenceLists" */ '@/views/attenceAnalysis/attence/index.vue'),
              name: 'attenceLists',
              meta: { title: '考勤列表' },
          },
          {
            path: 'pushSettings',
            component: () => import(/* webpackChunkName: "pushSettings" */ '@/views/attenceAnalysis/pushSettings/index.vue'),
            name: 'pushSettings',
            meta: { title: '推送设置' },
          },
      ]
    }
]

export default attenceAnalysisRouter
